import { Component, OnInit } from '@angular/core';
import { GridApi } from 'ag-grid-community';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { printMessage } from 'src/app/constants/service.constants';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { IstDataShareService } from '../../services/ist/ist-datashare.service';
import { DateObject, IST_APP, ModuleMenu } from 'src/app/models/common';
import { CommonService } from 'src/app/services/common.service';
import { HeadService } from 'src/app/services/common/headservice';
import { UserService } from 'src/app/services/user.service';
import { EapSummaryService } from '../../services/eap/eap-summary.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ColumnsSelectionPopupComponent, UserPreferenceColumns, UserPreferenceColumnsList } from 'src/app/common/columns-selection-popup/columns-selection-popup.component';

@Component({
  selector: 'app-eap-applications',
  templateUrl: './eap-applications.component.html',
  styleUrls: ['./eap-applications.component.scss']
})
export class EapApplicationsComponent implements OnInit {

  gridApi: GridApi;
    columnDefs: any[];
    collapesedOrNot:any
    operations: any[];
    tempoperations: any[];
    rowData;
    advanceSearch: any;
    selectedRow;
    caseDetails;
    studyType: any[];
    requestType: any[];
    StatusList: any;
    TherapeuticAreaList:any[];
    productList:any[];
    ApplicationTypeList: any[];
    istapp: IST_APP;
    menudata: ModuleMenu;
    EAPApplicationsSearch: UntypedFormGroup;
    isProduct:boolean=false;
    isHadPermission:boolean = false;
    maxDate = new Date() ; 
    myDate = new Date();  
    yesterday = new Date(this.myDate.setDate(new Date().getDate()+1));
    year = this.yesterday.getFullYear();
    moth = this.yesterday.getMonth() + 1;
    Day = this.yesterday.getDate();
    columns:any;
    userPreferenceColumnsLst: UserPreferenceColumnsList ;
    ApplicationID:string = '';
    ApplicationType:string = '';
    PhysicianName:string = '';
    TherapeuticArea:string = '';
    RequestType:string = '';
    Product:string = '';
    StudyType:string = '';
    Owner:string = '';
    Status:string = '';
    
  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private summaryService: EapSummaryService,
    private modalService: NgbModal,
    private dataShare: IstDataShareService,
    private commonService: CommonService,
    private header: HeadService,
    private userService: UserService
  ) {

  }

  ngOnInit() {
    this.columns = this.route.snapshot.data["items"][0];
    if(this.route.snapshot.data["items"][1] != null){
      this.userPreferenceColumnsLst = this.route.snapshot.data["items"][1];
    }
    this.requestType= [{ "value": "", "label": "All" }, { "value": "1", "label": "Funds" }, { "value": "2", "label": "Product" }, { "value": "3", "label": "Both" }];
   
    this.EAPApplicationsSearch = new UntypedFormGroup({
      Title: new UntypedFormControl(""),
      ApplicationType: new UntypedFormControl(""),
      PhysicianName: new UntypedFormControl(""),      
      Product: new UntypedFormControl(""),
      StudyType: new UntypedFormControl(""),
      Assignedto: new UntypedFormControl(""),
      Status: new UntypedFormControl(""),
      StartDate:new UntypedFormControl(null),
      EndDate: new UntypedFormControl(null),     
    });
       
    this.setUserPreferenceColumns();
    let chnageWonership = this.commonService.getScreenPermission("501","C");
    let hadeditPermission = this.commonService.getScreenPermission("501","E");
    if(chnageWonership || hadeditPermission)
    {
      this.isHadPermission=true;
    }
    this.advanceSearch ={
      "fields": [
        {
          "label": "Title",
          "field": "title",
          "type": "text"
        },
        {
          "label": "Physician Name",
          "field": "PhysicianName",
          "type": "text"
        },        
        {
          "label": "Product",
          "field": "Product",
          "type": "dropdown",
          "options": this.productList,
        },
        {
          "label": "Status",
          "field": "status",
          "type": "dropdown",
          "options": this.StatusList,
        }
      ],
      "filters": [
        {
          "label": "New Applications in last one week",
          "filter_key": "unique_key_1",
          "criteria": ""
        },
        {
          "label": "New Applicaitons in last one month",
          "filter_key": "unique_key_2",
          "criteria": ""
        },
        {
          "label": "New Applications in last one quarter",
          "filter_key": "unique_key_3",
          "criteria": ""
        },
        {
          "label": "New Applications in last one year",
          "filter_key": "unique_key_4",
          "criteria": ""
        }
      ]
    };


    this.caseDetails= [
    {
      "caseSet" : {
        "caseHeading": "General",
          "caseData" : [
            {
              "label": "Application ID",
              "value": "APPLICATION_CODE"
            },
            {
              "label": "Physician Name",
              "value": "PhysicianName"
            },            
            {
              "label": "Product",
              "value": "ProductName"
            },           
            {
              "label": "Status",
              "value": "STATUSStr"
            },
            {
              "label": "Submitted On",
              "value": "SubmittedOnStr"
            },
            {
              "label": "Last Updated On",
              "value": "LastUpdatedStr"
            },
            {
              "label": "IRB Name",
              "value": "IRBName"
            },
            {
              "label": "#Total Requests",
              "value": "totalRequests"
            },
            {
              "label": "#Closed Requests",
              "value": "closedRequests"
            }
          ]

      }
    }
   ];
 
    this.getSummaryData();
    this.GetStatusList();
    this.getApplicationtypes();
  }


  GetStatusList() {      
      this.summaryService.masterData("api/gmapp/getstatus/5").subscribe(result => {
        if (result != null) {
          this.StatusList = result;
          this.StatusList=  [{label:"Select",value:"-1", checked: true}, { label: "Returned", value: "Returned", checked: true }].concat(this.StatusList);  
        }
      });
    }
  
    getSummaryData() {
      this.SearchClear();
      this.summaryService.getApplicationSummary("api/EAPGeneralInfo/GetALLEAPApplicationsList").subscribe(summary => {
        this.rowData = summary["SummaryData"];
        this.studyType = summary["MasterDrops"].MasterData1;
        this.studyType = [{label:"Select",value:"",checked: true}].concat(this.studyType);  
        this.productList = summary["MasterDrops"].MasterData2;
        this.productList = [{label:"Select",value:"",checked: true}].concat(this.productList);       
      });
    }
  
    getApplicationtypes() {
      let submodule = "-1";
      let moduleID = "5";
      this.commonService.getAllApplicationTypesforSearch(moduleID, submodule).subscribe((result) => {
        if (result) {
          this.ApplicationTypeList = result;
        }
      });
    }
  
    getSummarySearch(searchObject: any) {
      this.summaryService.getEAPSearchSummary("api/EAPGeneralInfo/getALLEapSummarySearch", searchObject).subscribe(summary => {
        this.rowData = summary["SummaryData"];
      });
    }
  
    onAdvanceSearchOperation(searchFiletrs) {
      switch (searchFiletrs["OperationType"]) {
        case "viewall":
          this.SearchClear();
          this.getSummaryData();
          break;
        case "search":
          var searchObject = new Object();
          searchObject["Name"] = searchFiletrs["Name"];
          searchObject["ProductName"] = searchFiletrs["Product"];
          this.getSummarySearch(searchObject);
          break;
      }
    }
    onSetGridApi(gridApi){
      this.gridApi = gridApi;
    }
    onCallbackOperation(opr){
      opr.callback();
    }
  
    requestTypeChange(event) {
       
     let requestType= event.value;
     if (requestType != 1){ this.isProduct = false}
     else {this.isProduct = true}
    }
  
    onSelectionChanged(event) {
      this.selectedRow = this.gridApi.getSelectedRows()?this.gridApi.getSelectedRows()[0]:null;
    }
  
    onRowDoubleClicked(event) {
      this.commonService.removeLeftMenu();
      this.commonService.appId = event.data["ID"];
       this.commonService.refreshApplicationPage(event.data["ID"], "eap","","all");  
    }
  
  
  
    reject() {      
    }
  
    onHold() {     
    }
  
    submitfromDate(event){
      this.EAPApplicationsSearch.get('EndDate')?.setValue(null);
      this.Submit_from_date = {
        Day : event.getDate(),
        Month : event.getMonth()+1,
        Year : event.getFullYear(),
        Hours : 0,
        Minutes : 0,
        Seconds : 0,
        HasValue : true
  
      };
    }
    submitendDate(event){
      this.Submit_end_date = {
        Day : event.getDate(),
        Month : event.getMonth()+1,
        Year : event.getFullYear(),
        Hours : 23,
        Minutes : 59,
        Seconds : 59,
        HasValue : true  
      }  
    }
  
    Submit_from_date : DateObject;
    Submit_end_date : DateObject;
  
    //// Advace search Functions
    SearchClear() {
      this.EAPApplicationsSearch.reset();
    }
    AdvanceSearch() {
      var formData = this.EAPApplicationsSearch.value;
      formData["ApplicationID"] = "";      
      if (formData["StartDate"] != null && formData["StartDate"] != undefined && formData["StartDate"] != 'Invalid Date') 
      {     
        formData["StartDateO"] = this.Submit_from_date; 
      }
      if (formData["EndDate"] != null && formData["EndDate"] != undefined && formData["EndDate"] != 'Invalid Date') {
        formData["EndDateO"] = this.Submit_end_date;
      }
      this.getSummarySearch(formData);
    } 
  
    setUserPreferenceColumns(){
      this.columnDefs = [];
      this.columns.forEach(x=>{
        if(x.FieldCode == 'APPLICATION_ID'){
          this.ApplicationID = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "APPLICATION_CODE"
            }
          );
        }
        if(x.FieldCode == 'APPLICATION_TYPE'){
          this.ApplicationType = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName":  x.ColumnName,
              "field": "APPLICATION_TYPE_NAME"
            },
          );
        }
        if(x.FieldCode == 'PHYSICIAN_NAME'){
          this.PhysicianName = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "PhysicianName"
            }
          );
        }
        if(x.FieldCode == 'REQUEST_TYPE'){
          this.RequestType = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "REQUEST_TYPE_NAME"
            }
          );
        }
        if(x.FieldCode == 'OWNER'){
          this.Owner = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "AssignedTo"
            }
          );
        }
        if(x.FieldCode == 'STATUS'){
          this.Status = x.ColumnName;
          this.columnDefs.push(
            {
              "headerName": x.ColumnName,
              "field": "STATUSStr"
            }
          );
        }
        if (x.FieldCode == 'PRODUCTIDS') {
          this.Product = x.ColumnName;
          if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapAllApplications) {
            if (this.userPreferenceColumnsLst.EapAllApplications.PRODUCTIDS) {
              this.columnDefs.push(
                {
                  "headerName": x.ColumnName,
                  "field": "ProductName"
                },
              );
            }
          }
        }
        if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapAllApplications) {
          if (this.userPreferenceColumnsLst.EapAllApplications.SUBMITTED_ON && x.FieldCode == 'SUBMITTED_ON') {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "SubmittedOnStr"
              },
            );
          }
        }
        if (this.userPreferenceColumnsLst && this.userPreferenceColumnsLst.EapAllApplications) {
          if (this.userPreferenceColumnsLst.EapAllApplications.LAST_UPDATED_ON && x.FieldCode == 'LAST_UPDATED_ON') {
            this.columnDefs.push(
              {
                "headerName": x.ColumnName,
                "field": "LastUpdatedStr"
              }
            );
          }
        }
      })
      setTimeout(()=>{
        this.gridApi.refreshHeader();
        this.gridApi.sizeColumnsToFit();
        },500);
    }
  
    getUserPreferenceColumns(){
      this.commonService.GetUserPreferencesColumns().subscribe({
        next:res=>{
          if(res){
            this.userPreferenceColumnsLst = res;
          }
          this.setUserPreferenceColumns();
        }
      })
    }
  
    selectColumns($event){
        let modalRef = this.modalService.open(ColumnsSelectionPopupComponent, {
          backdrop: false,
          keyboard: false,
          windowClass: 'modal-md modal-dialog-center',
          animation: true
        });
        modalRef.componentInstance.Content = { columns: this.columns,moduleId:"5",isAllApplications: true};
        modalRef.result.then((result) => {
          this.getUserPreferenceColumns();
        });
  
      }
}
